module.exports = __webpack_public_path__ + "static/media/customer-review.06c7605a.svg";